import { createRoot } from 'react-dom/client'

import * as Sentry from '@sentry/react'

import { SENTRY_IGNORE_ERRORS } from '@emmacare/common/config/sentry'

import App from 'src/scenes/App'

const envTracesSampleRate = parseFloat(process.env.TRACES_SAMPLE_RATE ?? '')
const replaysOnErrorSampleRate = parseFloat(
  process.env.REPLAY_SAMPLE_RATE ?? ''
)

const tracesSampleRate =
  isNaN(envTracesSampleRate) ||
  envTracesSampleRate < 0 ||
  envTracesSampleRate > 1.0
    ? 0.05
    : envTracesSampleRate

const maintenance = false

if (
  typeof process.env.DISABLE_SENTRY === 'boolean' &&
  !process.env.DISABLE_SENTRY
) {
  Sentry.init({
    environment: process.env.ENVIRONMENT_TYPE || 'local',
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    dsn: 'https://b51cd46a7ef9457989505d59769db578@o259501.ingest.us.sentry.io/4504010469474304',
    // eslint-disable-next-line import/namespace
    replaysSessionSampleRate: tracesSampleRate,
    replaysOnErrorSampleRate,
    integrations: [
      // todo: change to Sentry.reactRouterV6BrowserTracingIntegration after react router update
      // https://docs.sentry.io/platforms/javascript/guides/react/
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false
      }),
      Sentry.replayCanvasIntegration()
    ],
    tracePropagationTargets: [
      'dev.emmacare-dev.com',
      'dev-api.emmacare-dev.com',
      'sandbox.emmacare-dev.com',
      'sandbox-api.emmacare-dev.com',
      'preprod.emmacare-dev.com',
      'preprod-api.emmacare-dev.com',
      'cdn.emmacare.com',
      'api.emmacare.com'
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate
  })
}

const container = document.getElementById('app')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(<App maintenance={maintenance} />)
